import HowHearFormContainer from './how_hear_form_container';

const HowHearForm = HowHearFormContainer;
export default HowHearForm;
